module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"startTime":"Start Time","endTime":"End Time"},"zh":{"startTime":"开始时间","endTime":"结束时间"},"mm":{"startTime":"စတင်သည့်အချိန်","endTime":"ပြီးဆုံးသည့်အချိန်"}}')
  delete Component.options._Ctor
}
